export function Sidepanel(panelid, buttonid) {
  this.panel = document.getElementById(panelid);
  this.button = document.getElementById(buttonid);
  this.container = document.createElement("div");
  this.container.className = "sp-container";
  this.panel.prepend(this.container);
  this.animMS = 600; //.5s in css transition
  this.isopen = false;
  this.isloaded = false;
  this.rowclick = null;
  this.ontoggle = null;
  this.url = "";
  this.openwidth = "28em";
  this.svg_template = function (transform) {
    return (
      '<svg width="16" height="41" viewBox="0 0 20 41">' +
      '<g fill="none" stroke="currentColor" stroke-width="2" ' +
      transform +
      ">" +
      '<path d="M2 2 L10 21 L2 39"/>' +
      '<path d="M7 2 L15 21 L7 39"/>' +
      "</g>" +
      "</svg>"
    );
  };
  this.osvg = this.svg_template("");
  this.flip = "transform='translate(20, 0) scale(-1, 1)'";
  this.csvg = this.svg_template(this.flip);
  this.button.onclick = this.Toggle.bind(this);
  return this;
}
Sidepanel.prototype.SetUrl = function (url) {
  if (this.url == url) return;
  this.isloaded = false;
  this.url = url;
  this.container.innerHTML = "";
};
Sidepanel.prototype.SetRowClick = function (f) {
  this.rowclick = f;
};
Sidepanel.prototype.SetOnToggle = function (f) {
  this.ontoggle = f;
};
Sidepanel.prototype.RoundToDay = function (ts) {
  var DAY = 24 * 60 * 60;
  return ts - (ts % DAY);
};
Sidepanel.prototype.LoadUrl = function () {
  if (this.isloaded || this.url == "") return;
  //send ajax request
  var xhttp = new XMLHttpRequest();
  var sp = this;
  const container = this.container;
  container.innerHTML = "<center><h3>Loading outage report</h3></center>";
  const tw = this.openwidth;
  xhttp.onreadystatechange = function () {
    if (this.readyState == 4 && this.status == 200) {
      container.innerHTML = this.responseText;
      sp.isloaded = true;
      if (container.childElementCount == 0) return;
      //make rows clickable
      var table = container.children[0].children[1];
      table.style.minWidth = tw;
      if (sp.rowclick != null) {
        for (let i = 1; i < table.rows.length; ++i) {
          const r = table.rows[i];
          const json = JSON.parse(r.cells[r.cells.length - 1].innerText);
          r.onclick = function (json) {
            sp.rowclick(json.ts, json.lat, json.lon, json.zoom);
          }.bind(null, json);
        }
      }
    }
  };
  xhttp.open("GET", this.url, true);
  xhttp.send();
};

Sidepanel.prototype.Toggle = function () {
  this.isopen = !this.isopen;
  if (this.ontoggle) {
    this.ontoggle(this.isopen ? -1 : 1);
  }
  if (this.isopen) {
    this.LoadUrl();
  }
  this.panel.classList.toggle("is-closed");
  const icon = this.button.children[0];
  icon.classList.toggle("is-closed");
};
